<template>
	<div>
		<div>
			<ProgressStepper class="stepper" v-bind:steps="steps" v-bind:currentStep="currentStep"></ProgressStepper>
			<h2>Mapping Tool</h2>

		</div>
		<div class="mapping-tool">

			<div v-if="currentStep == 0">
				<h3>Step 1: {{steps[0]}}</h3>
				<form class="form-inline">
					<div class="form-group" >
						<label class="control-label" for="acadid">Academy Id:</label>

						<input name="acadid" v-model="acadid" v-validate.initial="acadid" data-vv-rules="required|numeric" class="form-control" type="text">
						<button class="button raised" v-on:click="seachAcademy">Search</button>
						<p v-if="acaderror" class="text-danger">{{acaderror}}</p>

					</div>
				</form>
			</div>

      <div v-if="currentStep == 1">

        <p>Academy: {{academy.acadid}} - {{academy.acadName}}</p>
        <hr>
        <h3>Step 2: {{steps[1]}}</h3>
        <div class="container-fluid">
        	<div class="row">
        		<form class="form-inline">
					<div class="form-group">
						<label class="control-label" for="extCompRef">extCompRef: </label>
						<input name="extCompRef" v-model="extCompRef" type="text" v-validate.initial="extCompRef" data-vv-rules="required|numeric" class="form-control" id="extCompRef"></div>
						<button v-on:click="submitExtCompRef">Submit</button>
					</div>
				</form>
		        <div class="col-sm-4">
		        	<p v-if="ecrerror" class="text-danger">{{ecrerror}}</p>
		        </div>
		      </div>
	      </div>
      </div>

      <div v-if="currentStep == 2">
      	<p>Academy: {{academy.acadid}} - {{academy.acadName}}</p>
      	<p>extCompRef: {{ecr.extCompRef}} - {{ecr.company}}</p>
      	<hr>
		<h3>Step 3: {{steps[2]}}</h3>

		 <div class="form-inline">
        	<select v-model="location">
				<option v-for="option in locations" v-bind:value="option">
					{{option.nodeid}} - {{ option.description }}
				</option>
			</select>
			<button v-on:click="submitLocation">Select</button>
        </div>
      </div>

      <div v-if="currentStep == 3">
      	<h3>Step 4: {{steps[3]}}</h3>
		<p>Academy: {{academy.acadid}} - {{academy.acadName}}</p>
      	<p>extCompRef: {{ecr.extCompRef}} - {{ecr.company}}</p>
      	<p>Location: {{location.nodeid}} - {{location.description}}</p>
      	<hr>
      	<div><button v-on:click="confirmCreateMapping">Confirm and Create Mapping</button></div>
      </div>

      <div v-if="currentStep == 4">
      	<h3>Mapping Created</h3>
		<p>Academy: {{academy.acadid}} - {{academy.acadName}}</p>
      	<p>extCompRef: {{ecr.extCompRef}} - {{ecr.company}}</p>
      	<p>Location: {{location.nodeid}} - {{location.description}}</p>
      	<hr>

			<p><button v-on:click="reset">Add Another Mapping</button></p>
      </div>

		</div>
	</div>
</template>

<script>
import ProgressStepper from './ProgressStepper'
import { Validator } from 'vee-validate'
import _ from 'underscore'

export default{
	components: { ProgressStepper },
	name: 'mapping-tool',
	data () {
		return {
			acadid: '',
			extCompRef: '',
			nodeid: '',
			nodeloc: 'All',
			location: null,
			steps: [ 'Search Academy', 'Enter extCompRef', 'Select Location', 'Confirm Mapping' ]
		}
	},
	computed: {
		academy () {
			return this.$store.state.mapping.academy
		},
		acadName () {
			return 'TODO get name'
		},
		clientid () {
			return (this.nodeloc === 'All') ? 'all' : this.nodeid
		},
		acaderror () {
			if (this.errors.has('acadid')) {
				return this.errors.first('acadid')
			}
			if (this.$store.state.mapping.error) {
				return this.$store.state.mapping.error
			}
			return
		},
		ecrerror () {
			if (this.errors.has('extCompRef')) {
				return this.errors.first('extCompRef')
			}
			if (this.$store.state.mapping.error) {
				return this.$store.state.mapping.error
			}
			return
		},
		locations () {
			return this.$store.state.mapping.ecr.nodes
		},
		location: {
			get () {
				return this.$store.state.mapping.location
			},
			set (loc) {
				this.$store.commit('setNewMappingLocation', loc)
			}
		},
		ecr () {
			return this.$store.state.mapping.ecr
		},
		currentStep () {
			return this.$store.state.mapping.step
		},
		completed () {
			return this.$store.state.mapping.completed
		}
	},
	methods: {
		seachAcademy (e) {
			e.preventDefault()
			this.$validator.validateAll()
			if (!this.errors.has('acadid')) {
				this.$store.dispatch('acadLookup', this.acadid)
			}
		},
		confirmCreateMapping (e) {
			this.$store.dispatch('createNewMapping', {
				extCompRef: this.ecr.extCompRef,
				company: this.ecr.company,
				description: this.location.description,
				nodeid: this.location.nodeid,
				acadid: this.academy.acadid,
				acadname: this.academy.acadName
			})
		},
		submitExtCompRef (e) {
			e.preventDefault()
			this.$validator.validateAll()
			if (!this.errors.has('extCompRef')) {
				this.$store.dispatch('getExtCompRef', this.extCompRef)
			}
		},
		submitLocation (e) {
			e.preventDefault()
			this.$store.commit('setNewMappingStep', 3)
		},
		reset () {
			this.acadid = ''
			this.extCompRef = ''
			this.$store.commit('clearNewMappingData')
		}
	},
	beforeMount () {
		// console.log('PARAMS', this.$route.params)
		this.$store.commit('clearNewMappingData')
		if (this.$route.params.acadid) {
			let id = this.acadid = this.$route.params.acadid
			let acad = _.findWhere(this.$store.state.academiesList, { id: id })
			this.$store.commit('setAcademyInfo', {
				acadid: id,
				acadName: acad.name
			})
			this.$store.commit('setNewMappingStep', 1)
		} else {
			this.reset()
		}

		Validator.updateDictionary({
			en: {attributes: {
				toName: 'Schoox Job Name',
				nodeid: 'Location/Node ID',
				nodeloc: 'Mapped Location/Node'
			}}
		})
	}
}
</script scoped>

<style>
.mapping-tool{
  margin-top:20px;
}

.stepper{
	float:right;
	width:600px;
	margin-top: 20px;
}
.mapping-tool label {
	padding-right:10px;
}
</style>


// WEBPACK FOOTER //
// MappingTool.vue?77f33d4d